import { useCallback } from 'react';

export function useAmountValidation(handleBetSectionsState, limits, regex) {
  const onChange = useCallback(
    (event) => {
      const {
        target: { value },
      } = event;
      const value1 = String(+value);
      if (regex.test(value1)) {
        return handleBetSectionsState({ changeBet: value });
      }
      if (value1 === '') {
        return handleBetSectionsState({ changeBet: value });
      }
      return null;
    },
    [handleBetSectionsState, regex]
  );
  return { onChange };
}
